import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    nav: {
      folgo: 'FOLGO',
      cargo: 'CARGO',
      kitCadre: 'KIT CADRE',
      accessoires: 'ACCESSOIRES',
      faq: 'FAQ',
      contact: 'CONTACT'
    },
    // Hero
    hero: {
      subtitle: 'Vélos cargo urbains',
      title1: 'Belleville',
      title2: 'Machine',
      description: 'Des vélos cargo conçus pour la ville. Robustes, polyvalents et entièrement personnalisables.',
      ctaDiscover: 'Découvrir le FOLGO',
      ctaContact: 'Nous contacter'
    },
    // Products
    products: {
      subtitle: 'Nos modèles',
      title: 'La gamme',
      folgoDesc: 'Vélo cargo compact et polyvalent',
      cargoDesc: 'Vélo cargo grande capacité',
      kitDesc: 'Pour les monteurs expérimentés',
      fromPrice: 'À partir de'
    },
    // Features
    features: {
      madeInFrance: 'Fabrication française',
      madeInFranceDesc: 'Conçus et assemblés dans notre atelier parisien',
      freeDelivery: 'Livraison offerte',
      freeDeliveryDesc: 'Livraison gratuite en France métropolitaine',
      warranty: 'Garantie 2 ans',
      warrantyDesc: 'Cadre et composants garantis 2 ans'
    },
    // CTA
    cta: {
      title: 'Prêt à rouler ?',
      description: 'Configurez votre vélo cargo sur mesure et recevez-le chez vous.',
      button: 'Configurer mon vélo'
    },
    // Configurator
    config: {
      price: 'Prix',
      transmission: 'Type de transmission',
      street: 'Street',
      streetDesc: 'Usage urbain quotidien',
      gravel: 'Gravel',
      gravelDesc: 'Polyvalent route/chemin',
      plateaux: 'Plateaux',
      plateau1: '1 plateau',
      plateau1Desc: 'Simple et léger',
      plateau2: '2 plateaux',
      plateau2Desc: 'Plus de plage de vitesses',
      vitesses: 'Vitesses',
      vitesses11: '11 vitesses',
      vitesses11Desc: 'Configuration standard',
      vitesses12: '12 vitesses',
      vitesses12Desc: 'Configuration premium (+50€)',
      guidon: 'Guidon',
      guidonVtt: 'Guidon VTT',
      guidonVttDesc: 'Position droite',
      guidonGravel: 'Guidon Gravel',
      guidonGravelDesc: 'Position courbée',
      potence: 'Potence',
      short: 'Court',
      standard: 'Standard',
      long: 'Long',
      couleur: 'Couleur',
      bleu: 'Bleu',
      noir: 'Noir',
      vert: 'Vert',
      rouge: 'Rouge',
      taille: 'Taille',
      axe: "Type d'axe",
      axeQR: 'Axe QR',
      axeQRDesc: 'Quick Release standard',
      axeTraversant: 'Axe traversant',
      axeTraversantDesc: 'Plus rigide',
      addToCart: 'Ajouter au panier'
    },
    // Cart
    cart: {
      title: 'Votre Panier',
      empty: 'Votre panier est vide',
      remove: 'Supprimer',
      total: 'Total',
      checkout: 'Commander',
      added: 'Produit ajouté au panier'
    },
    // Checkout
    checkout: {
      back: 'Retour',
      title: 'Finaliser la commande',
      yourInfo: 'Vos coordonnées',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      postalCode: 'Code postal',
      city: 'Ville',
      height: 'Votre taille (cm) - optionnel',
      paymentMethod: 'Mode de paiement',
      cardTotal: 'Carte bancaire - Paiement total',
      cardDeposit: 'Carte bancaire - Acompte 50%',
      bankTransfer: 'Virement bancaire',
      payNow: 'Payer maintenant',
      validateOrder: 'Valider la commande',
      processing: 'Traitement...',
      summary: 'Récapitulatif',
      subtotal: 'Sous-total',
      delivery: 'Livraison',
      free: 'Offerte',
      deposit: 'Acompte (50%)',
      toPayNow: 'À payer maintenant',
      transferValidation: 'Validé manuellement après réception'
    },
    // Success
    success: {
      checking: 'Vérification du paiement...',
      pleaseWait: 'Veuillez patienter',
      thanks: 'Merci !',
      confirmed: 'Votre paiement a été confirmé. Vous recevrez un email de confirmation sous peu.',
      amountPaid: 'Montant payé',
      returnHome: "Retour à l'accueil",
      failed: 'Échec du paiement',
      failedDesc: "Le paiement n'a pas pu être complété. Veuillez réessayer ou nous contacter.",
      retry: 'Réessayer',
      contactUs: 'Nous contacter'
    },
    // Transfer
    transfer: {
      title: 'Paiement par virement',
      description: 'Effectuez votre virement avec les informations ci-dessous. Votre commande sera validée dès réception.',
      beneficiary: 'Bénéficiaire',
      reference: 'Référence de commande (à indiquer)',
      important: 'Important',
      note1: 'Indiquez bien la référence de commande dans le libellé du virement',
      note2: 'Votre commande sera validée sous 24-48h après réception du paiement',
      note3: 'Vous recevrez un email de confirmation une fois le paiement validé'
    },
    // Accessories
    accessories: {
      subtitle: 'Équipez votre vélo',
      title: 'Accessoires',
      add: 'Ajouter',
      housse: 'Housse de protection',
      housseDesc: 'Housse imperméable haute qualité pour protéger votre vélo cargo des intempéries.',
      bequille: 'Béquille double',
      bequilleDesc: 'Béquille renforcée spécialement conçue pour vélo cargo. Stabilité maximale.',
      siegeBebe: 'Siège bébé',
      siegeBebeDesc: 'Siège bébé homologué avec harnais 5 points. Confort et sécurité pour votre enfant.'
    },
    // FAQ
    faq: {
      subtitle: 'Questions fréquentes',
      title: 'FAQ',
      description: 'Retrouvez les réponses aux questions les plus fréquentes'
    },
    // Contact
    contact: {
      subtitle: 'Contactez-nous',
      title: 'Contact',
      meetUs: 'Venez nous rencontrer',
      meetDesc: 'Notre showroom est ouvert du lundi au vendredi de 10h à 18h. Prenez rendez-vous pour essayer nos vélos.',
      address: 'Adresse',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      sent: 'Message envoyé ! Nous vous répondrons rapidement.'
    },
    // Footer
    footer: {
      description: 'Vélos cargo urbains conçus et assemblés en France.',
      products: 'Produits',
      support: 'Support',
      rights: 'Tous droits réservés.',
      cgv: 'CGV',
      legal: 'Mentions légales'
    },
    // Kit Cadre
    kit: {
      subtitle: 'Choisissez votre kit',
      title: 'Kits Cadre',
      folgoDesc: 'Kit cadre FOLGO pour montage personnalisé. Inclut le cadre, la fourche et la direction.',
      cargoDesc: 'Kit cadre CARGO pour montage personnalisé. Inclut le cadre, la fourche et la direction.'
    }
  },
  en: {
    // Navigation
    nav: {
      folgo: 'FOLGO',
      cargo: 'CARGO',
      kitCadre: 'FRAME KIT',
      accessoires: 'ACCESSORIES',
      faq: 'FAQ',
      contact: 'CONTACT'
    },
    // Hero
    hero: {
      subtitle: 'Urban cargo bikes',
      title1: 'Belleville',
      title2: 'Machine',
      description: 'Cargo bikes designed for the city. Robust, versatile and fully customizable.',
      ctaDiscover: 'Discover FOLGO',
      ctaContact: 'Contact us'
    },
    // Products
    products: {
      subtitle: 'Our models',
      title: 'The range',
      folgoDesc: 'Compact and versatile cargo bike',
      cargoDesc: 'High capacity cargo bike',
      kitDesc: 'For experienced builders',
      fromPrice: 'From'
    },
    // Features
    features: {
      madeInFrance: 'Made in France',
      madeInFranceDesc: 'Designed and assembled in our Paris workshop',
      freeDelivery: 'Free delivery',
      freeDeliveryDesc: 'Free shipping in metropolitan France',
      warranty: '2-year warranty',
      warrantyDesc: 'Frame and components guaranteed for 2 years'
    },
    // CTA
    cta: {
      title: 'Ready to ride?',
      description: 'Configure your custom cargo bike and have it delivered to your door.',
      button: 'Configure my bike'
    },
    // Configurator
    config: {
      price: 'Price',
      transmission: 'Transmission type',
      street: 'Street',
      streetDesc: 'Daily urban use',
      gravel: 'Gravel',
      gravelDesc: 'Versatile road/trail',
      plateaux: 'Chainrings',
      plateau1: '1 chainring',
      plateau1Desc: 'Simple and light',
      plateau2: '2 chainrings',
      plateau2Desc: 'More gear range',
      vitesses: 'Speeds',
      vitesses11: '11 speed',
      vitesses11Desc: 'Standard configuration',
      vitesses12: '12 speed',
      vitesses12Desc: 'Premium configuration (+€50)',
      guidon: 'Handlebar',
      guidonVtt: 'MTB Handlebar',
      guidonVttDesc: 'Upright position',
      guidonGravel: 'Gravel Handlebar',
      guidonGravelDesc: 'Drop bar position',
      potence: 'Stem',
      short: 'Short',
      standard: 'Standard',
      long: 'Long',
      couleur: 'Color',
      bleu: 'Blue',
      noir: 'Black',
      vert: 'Green',
      rouge: 'Red',
      taille: 'Size',
      axe: 'Axle type',
      axeQR: 'QR Axle',
      axeQRDesc: 'Standard Quick Release',
      axeTraversant: 'Thru-axle',
      axeTraversantDesc: 'More rigid',
      addToCart: 'Add to cart'
    },
    // Cart
    cart: {
      title: 'Your Cart',
      empty: 'Your cart is empty',
      remove: 'Remove',
      total: 'Total',
      checkout: 'Checkout',
      added: 'Product added to cart'
    },
    // Checkout
    checkout: {
      back: 'Back',
      title: 'Complete your order',
      yourInfo: 'Your details',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      postalCode: 'Postal code',
      city: 'City',
      height: 'Your height (cm) - optional',
      paymentMethod: 'Payment method',
      cardTotal: 'Credit card - Full payment',
      cardDeposit: 'Credit card - 50% deposit',
      bankTransfer: 'Bank transfer',
      payNow: 'Pay now',
      validateOrder: 'Validate order',
      processing: 'Processing...',
      summary: 'Summary',
      subtotal: 'Subtotal',
      delivery: 'Delivery',
      free: 'Free',
      deposit: 'Deposit (50%)',
      toPayNow: 'To pay now',
      transferValidation: 'Validated manually upon receipt'
    },
    // Success
    success: {
      checking: 'Checking payment...',
      pleaseWait: 'Please wait',
      thanks: 'Thank you!',
      confirmed: 'Your payment has been confirmed. You will receive a confirmation email shortly.',
      amountPaid: 'Amount paid',
      returnHome: 'Return to home',
      failed: 'Payment failed',
      failedDesc: 'The payment could not be completed. Please try again or contact us.',
      retry: 'Try again',
      contactUs: 'Contact us'
    },
    // Transfer
    transfer: {
      title: 'Bank transfer payment',
      description: 'Make your transfer with the information below. Your order will be validated upon receipt.',
      beneficiary: 'Beneficiary',
      reference: 'Order reference (to include)',
      important: 'Important',
      note1: 'Include the order reference in the transfer description',
      note2: 'Your order will be validated within 24-48h after payment receipt',
      note3: 'You will receive a confirmation email once the payment is validated'
    },
    // Accessories
    accessories: {
      subtitle: 'Equip your bike',
      title: 'Accessories',
      add: 'Add',
      housse: 'Protective cover',
      housseDesc: 'High quality waterproof cover to protect your cargo bike from the elements.',
      bequille: 'Double kickstand',
      bequilleDesc: 'Reinforced kickstand specially designed for cargo bikes. Maximum stability.',
      siegeBebe: 'Baby seat',
      siegeBebeDesc: 'Approved baby seat with 5-point harness. Comfort and safety for your child.'
    },
    // FAQ
    faq: {
      subtitle: 'Frequently asked questions',
      title: 'FAQ',
      description: 'Find answers to the most frequently asked questions'
    },
    // Contact
    contact: {
      subtitle: 'Contact us',
      title: 'Contact',
      meetUs: 'Come meet us',
      meetDesc: 'Our showroom is open Monday to Friday from 10am to 6pm. Make an appointment to try our bikes.',
      address: 'Address',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      sending: 'Sending...',
      sent: 'Message sent! We will respond shortly.'
    },
    // Footer
    footer: {
      description: 'Urban cargo bikes designed and assembled in France.',
      products: 'Products',
      support: 'Support',
      rights: 'All rights reserved.',
      cgv: 'Terms',
      legal: 'Legal notice'
    },
    // Kit Cadre
    kit: {
      subtitle: 'Choose your kit',
      title: 'Frame Kits',
      folgoDesc: 'FOLGO frame kit for custom build. Includes frame, fork and headset.',
      cargoDesc: 'CARGO frame kit for custom build. Includes frame, fork and headset.'
    }
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('bm_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('bm_language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
